import React from "react";

/* Keeps one broken section from blanking the whole site. */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    render() {
        if (this.state.error) {
            return (
                <div className="wrap flex min-h-[60vh] flex-col items-start justify-center py-24">
                    <p className="eyebrow">Something went wrong</p>
                    <h1 className="mt-4 text-3xl sm:text-4xl">
                        This page did not load properly.
                    </h1>
                    <a
                        href="/"
                        className="btn-primary mt-8"
                        data-testid="error-recover-link"
                    >
                        Back to the home page
                    </a>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
